import Meta from "antd/es/card/Meta";
import {Card} from "antd";

const ServerCard = ({imgUrl = {}, title = "", content = ''}) => {
    return (
        <Card hoverable
              style={{
                  width: '275px',
                  height: '530px',
                  overflow: 'hidden',
              }}
              cover={<img alt={title} src={imgUrl}/>}
        >
            <Meta title={title} description={content}/>
        </Card>
    )
}

export default ServerCard;